<script>
import cBreadcrumbItem from './cBreadcrumbItem.vue';
import i18n from '@/i18n';
import { h, resolveComponent } from 'vue';

export default {
  name: 'cBreadcrumb',
  data() {
    return {};
  },
  components: { cBreadcrumbItem },
  props: {
    routeItem: {
      type: Array,
      default: () => {}
    },
    rootPath: {
      type: String,
      default: '/'
    },
    rootName: {
      type: String,
      default: i18n.global.t('label.home')
    },
    separatorIcon: {
      type: String,
      default: 'collapse_menu'
    }
  },
  emits: ['rootClick', 'itemClick'],
  computed: {},
  methods: {
    onItemClick(item, val) {
      if (val === 'root') {
        this.$emit('rootClick', item);
      } else {
        this.$emit('itemClick', item);
      }
    }
  },
  render() {
    const { $theme, routeItem, rootName, rootPath, separatorIcon } = this;
    const cBreadcrumbItem = resolveComponent('c-breadcrumb-item');
    const legoIcon = resolveComponent('lego-icon');
    const pathRootDom = h(
      'li',
      {
        key: 'root',
        class: 'c-breadcrumb__item c-breadcrumb__item--root'
      },
      [
        h(cBreadcrumbItem, {
          label: rootName,
          onItemClick: () => {
            this.onItemClick({ name: rootName, path: rootPath }, 'root');
          }
        })
      ]
    );

    const separatorIconDom = h(legoIcon, {
      iconType: 'df',
      icon: 'arrow_right',
      iconSize: '16px',
      color: '#818898'
    });

    const pathDom = routeItem.map((segment, idx) => {
      return h('li', { key: idx, class: 'c-breadcrumb__item' }, [
        separatorIconDom,
        h(cBreadcrumbItem, {
          current: routeItem.length === idx + 1,
          label: segment.text,
          color: routeItem.length === idx + 1 ? $theme.COLOR.PRIMARY.BASE : null,
          onItemClick: () => {
            this.onItemClick(
              {
                text: segment.text,
                path: segment.path,
                param: segment.param || null,
                query: segment.query || null
              },
              'sub'
            );
          }
        })
      ]);
    });

    return h(
      'ul',
      {
        class: {
          'c-breadcrumb': true
        }
      },
      [pathRootDom, pathDom]
    );
  }
};
</script>
<style lang="scss" scoped>
.c-breadcrumb {
  display: flex;
  align-items: center;
  gap: 4px;

  .c-breadcrumb__item {
    display: flex;
    align-items: center;
    gap: 3px;
  }
  .c-breadcrumb__item--root {
    .c-label:hover {
      color: #2c59d9 !important;
      text-decoration: underline;
    }
  }
}
</style>
